import React from 'react'
import BaseStep from '../BaseStep'
import CardSelectable from '../commons/CardSelectable'
import Back from '../commons/Back'
import GenericIcon from 'components/GenericIcon'

class RefinanceReason extends BaseStep {

  onClick = (answer) => {
    this.props.onChoice({ refinanceReason: answer })
  }

  answerText = (answer) => {
    let { loanTarget } = this.props
    return I18n.t(`onboarding.refinance_reason.${loanTarget}.answer.${answer}`)
  }

  render() {
    let { loanTarget } = this.props

    return (
      <div ref={ (ref) => this.cardsContainer = ref } >
        <h3 className="onboarding-title text-center">
          { I18n.t(`onboarding.refinance_reason.${loanTarget}.question`) }
        </h3>
        <div className="row">
          <div className="col-sm-4">
            <CardSelectable
              onClick={ () => this.onClick('better_deal') }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='handshake' />
              <h4>{ this.answerText('better_deal') }</h4>
            </CardSelectable>
          </div>

          <div className="col-sm-4">
            <CardSelectable
              onClick={ () => this.onClick('consolidate_debt') }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='calculator' />
              <h4>{ this.answerText('consolidate_debt') }</h4>
            </CardSelectable>
          </div>

          <div className="col-sm-4">
            <CardSelectable
              onClick={ () => this.onClick('cash_out') }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='dollarMine' />
              <h4>{ this.answerText('cash_out') }</h4>
            </CardSelectable>
          </div>

        </div>
        <Back onGoBack={this.props.onGoBack} />
      </div>
    )
  }
}

export default RefinanceReason;
